import { useContext, useEffect, useRef, useState } from 'react';
import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import EditorFilterFamilyOptions from './EditorFilterFamilyOptions';
import EditorFixedHeaderContainer from './EditorFixedHeaderContainer';
import EditorTitleHeader from './EditorTitleHeader';
import EditorFilterSelectNav from './EditorFilterSelectNav';
import EditorObjectTypeSelect from './EditorObjectTypeSelect';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFilterFamilySelect = () => {
  const {
    selectedFilterFamilyGroup,
    props: {
      uiMessages: {
        filterCategorySearchInputPlaceholder
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const [searchString, setSearchString] = useState('');
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  useEffect(() => {
    setSearchString('');
  }, [selectedFilterFamilyGroup]);
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-test": "fr-select-filter-family-panel",
    style: {
      all: 'inherit'
    },
    children: [/*#__PURE__*/_jsxs(EditorFixedHeaderContainer, {
      children: [/*#__PURE__*/_jsx(EditorTitleHeader, {}), /*#__PURE__*/_jsx(EditorObjectTypeSelect, {}), /*#__PURE__*/_jsx(EditorFilterSelectNav, {}), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.filterFamilySelectLabel'),
        children: /*#__PURE__*/_jsx(SearchInput, {
          "data-selenium-test": "fr-filter-search-input",
          inputRef: inputRef,
          onChange: evt => setSearchString(evt.target.value),
          placeholder: filterCategorySearchInputPlaceholder || I18n.text('newCustomerDataFilters.fieldSelectFlow.filterFamilySelectPlaceholder'),
          value: searchString
        })
      })]
    }), /*#__PURE__*/_jsx(EditorFilterFamilyOptions, {
      searchString: searchString
    })]
  });
};
export default EditorFilterFamilySelect;